import { useUser } from '@clerk/nextjs';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

/**
 * Helper component to set the Datadog user context based on the Clerk user.
 */
export const SetDatadogUser: React.FC = () => {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded) return;
    if (user) {
      const userAttributes = {
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        name: user.fullName ?? undefined,
      };
      datadogRum.setUser(userAttributes);
      datadogLogs.setGlobalContextProperty('user', userAttributes);
    } else {
      datadogRum.clearUser();
      datadogLogs.removeGlobalContextProperty('user');
    }
  }, [isLoaded, user]);
  return null;
};
